// AB test: starting_donation_on_frp_with_amount_page
// Can be removed when experiment has ended

import React, { createContext, useState } from 'react';
import { Variation } from '../utils/abTests';

type DonationAmountContext = {
  defaultDonationAmount: number;
  donationAmount: number | undefined;
  setDonationAmount: React.Dispatch<React.SetStateAction<number | undefined>>;
  hideDonationAmount: boolean;
  setHideDonationAmount: React.Dispatch<React.SetStateAction<boolean>>;
  showDonationAmountVariant: Variation | undefined;
  setShowDonationAmountVariant: React.Dispatch<
    React.SetStateAction<Variation | undefined>
  >;
};

export const DonationAmountContext = createContext<
  DonationAmountContext | undefined
>(undefined);

export const DonationAmountProvider: React.FunctionComponent = ({
  children,
}) => {
  const [donationAmount, setDonationAmount] = useState<number | undefined>(
    undefined,
  );
  const [hideDonationAmount, setHideDonationAmount] = useState(false);
  const [showDonationAmountVariant, setShowDonationAmountVariant] = useState<
    Variation | undefined
  >(undefined);

  return (
    <DonationAmountContext.Provider
      value={{
        defaultDonationAmount: 30, // Hard-coded default amount during test
        donationAmount,
        setDonationAmount,
        hideDonationAmount,
        setHideDonationAmount,
        showDonationAmountVariant,
        setShowDonationAmountVariant,
      }}
    >
      {children}
    </DonationAmountContext.Provider>
  );
};
